import * as React from 'react';

import { ImageProps } from 'components/atoms/Image';
import UIAsset from 'components/atoms/UIAsset';
import { CardTypes } from 'defs/card-types';
import { CardTypeTypes } from 'types/Card';

export type PlaceholderImagePropsType = {
	id: number;
	type: CardTypeTypes;
	previewImage?: ImageProps;
};

const PlaceholderImage = ({ type, previewImage, id }: PlaceholderImagePropsType) => {
	switch (type) {
		case CardTypes.Recipe:
		case CardTypes.DynamicProduct:
		case CardTypes.Workout:
			return <div />;
		default:
			const filterId = `m-card-preview-filter-${id}`;

			const imageSrc =
				!!previewImage &&
				!!previewImage.srcset &&
				!!previewImage.srcset.renditions &&
				!!previewImage.srcset.renditions[0]
					? previewImage.srcset.renditions[0].x1
					: '';
			return (
				<div className="m-card__preview">
					<svg
						className="m-card__preview-image-wrapper"
						preserveAspectRatio="xMidYMid slice"
						viewBox="0 0 500 333"
					>
						{previewImage && previewImage.original && (
							<image
								className="m-card__preview-image"
								width="100%"
								height="100%"
								xlinkHref={imageSrc}
								style={{ filter: `url(#${filterId})` }}
							/>
						)}
						<filter id={filterId}>
							<feGaussianBlur stdDeviation="4.8" />
						</filter>
					</svg>
					<UIAsset className="m-card__preview-content" src={`img/card/card-preview-${type}.png`} alt="" />
				</div>
			);
	}
};

PlaceholderImage.displayName = 'Card(PlaceholderImage)';

export default PlaceholderImage;
